// calendarUtils.js

export const getMonthDays = (year, month) => {

    const firstDay = new Date(year, month, 1);

    const lastDay = new Date(year, month + 1, 0);

    const days = [];

    const startDay = firstDay.getDay();

    const totalDays = lastDay.getDate();


    for(let i = 0; i < startDay; i++){

        days.push(null);

    }


    for(let day = 1; day <= totalDays; day++){

        days.push(
            new Date(
                year,
                month,
                day
            )
        );

    }


    while(days.length % 7 !== 0){

        days.push(null);

    }


    return days;

};



export const formatDate = (date) => {

    if(!date) return null;

    return date
        .toISOString()
        .split("T")[0];

};



export const buildDailySummary = (records)=>{

    const summary = {};


    records.forEach(record=>{

        const date = record.date?.substring(0,10);


        if(!summary[date]){

            summary[date]={
                score:0,
                count:0,
                duration:0,
                activities:0,
                mood:0,
                energy:0
            };

        }


        summary[date].score += Number(record.score)||0;

        summary[date].count++;

        summary[date].duration += Number(record.duration)||0;

        summary[date].activities++;

        summary[date].mood += Number(record.mood)||0;

        summary[date].energy += Number(record.energy)||0;


    });


    Object.keys(summary).forEach(date=>{

        const item = summary[date];


        item.averageScore =
            Number(
                (
                    item.score /
                    item.count
                ).toFixed(1)
            );


        item.averageMood =
            Number(
                (
                    item.mood /
                    item.count
                ).toFixed(1)
            );


        item.averageEnergy =
            Number(
                (
                    item.energy /
                    item.count
                ).toFixed(1)
            );


    });


    return summary;

};